<template>
  <v-app>
    <v-content>
      <errorMessages v-if="errorMessage"/>
      <div class="AppPadding">
        <router-view />
      </div>
    <autoLogoutPopup v-if="isAuthenticated"/>
    </v-content>
    <toastMessage/>
  </v-app>
</template>

<script>
import errorMessages from './components/error'
import autoLogoutPopup from './components/autoLogout.vue'
import toastMessage from './components/toast/toastMessage.vue'
import { mapGetters } from 'vuex'
// import JwtService from './common/jwt.service'

export default {
  name: 'App',
  components: {
    errorMessages,
    autoLogoutPopup,
    toastMessage
  },
  computed: {
    ...mapGetters(['isAuthenticated']),
    errorType: function () {
      return this.$store.state.auth.errorType
    },
    errorMessage: function () {
      // this.$store.auth.isAuthenticated = false
      // this.$store.auth.user = {}
      // this.$store.auth.errors = null
      // JwtService.destroyToken()
      // window.localStorage.clear()
      // window.location.href = '/login'
      return this.$store.state.auth.errorMessage !== null
    }
  },
  data () {
    return {
      //
    }
  }
}
</script>

<style>
  .child-flex>*, .flex {
    padding: 0.2rem;
  }

  .theme--light.v-application {
    background: #e7edf0;
    color: rgba(0,0,0,.87);
  }
  .v-application .rtsPrimary {
    background-color: #6aa58b !important;
    border-color: #6aa58b !important;
    border-radius: 0px;
  }
  .v-application .primary {
    border-radius: 0px;
  }
  .v-application .error {
    border-radius: 0px;
  }
  .theme--light.v-card, .theme--light.v-list {
    background: #fff;
    color: rgba(0,0,0,.87);
    height: 100% !important;
  }
</style>
